export default __webpack_public_path__ + "static/media/ordering.02d3ca7f.jpg";